import sdk from '@xiaoduo/plugin_sdk'
import mainShare from './mainShare'
import { isDev } from './cgate_util'
import { human_qa_three_remark_in_session_data } from './mock/human_qa_three_remark_in_session_data'

export default function pluginInit() {
  console.log('【plugin】 init plugin')
  sdk.updateConfig({
    projectKey: 'xiaoduo-front-ums', // TOOD: 修改成你的项目名
    refreshInterval: 30 * 60 * 1000, // 30分钟刷新一次
    // fetchPluginListUrl: 'http://cuhorh.10.0.1.219.nip.io/api/plugin/listForSdk', // TODO: 上线前改成线上环境
    // isDev, // 开发模式下使用本地插件列表
    // isDev: true,
    devBind: {
      'tenant_id=q-628cd3dc42a54bad238786e9': [
        // 线上 小仙炖
        {
          identifier: 'addOrder_1721810091346',
          name: 'addOrder',
          // 北京小仙炖生物科技有限公司
          extraParams:
            '{"tenantId": "q-63089c39ca3a0bc14841e15a", "appKey": "t00307", "appSecret": "o0wUIAVF9_mW3MG7"}',
        },
      ],
      'tenant_id=q-6195ba40cf625dcdbd5fbb54': [
        {
          identifier: 'addOrder_1721810091346',
          name: 'addOrder',
          extraParams:
            '{"tenantId": "q-6125fb72c8b62f6fb32fc091", "appKey": "c00001", "appSecret": "ficlapxm3F02aAd0"}',
        },
        {
          identifier: 'HumanQaThreeRemarkInSession_1729602275023',
          name: 'HumanQaThreeRemarkInSession',
          extraParams: JSON.stringify(human_qa_three_remark_in_session_data),
        },
      ], // 测试环境
      //测试lane
      'tenant_id=q-61efc5e2510b15909ddcb2af': [
        {
          identifier: 'HumanQaThreeRemarkInSession_1729602275023',
          name: 'HumanQaThreeRemarkInSession',
          extraParams: JSON.stringify(human_qa_three_remark_in_session_data),
        },
        {
          identifier: 'ShowCustomerAllOrderList_1726026728970',
          name: 'ShowCustomerAllOrderList',
          extraParams: JSON.stringify({
            month: 12,
          }),
        },
      ],

      'tenant_id=q-63563e97292f2a3ecb596b74': [
        {
          identifier: 'chatHistorySyncDiffVoc_1749540023141',
          name: 'chatHistorySyncDiffVoc',
          extraParams: JSON.stringify({
            data: [
              {
                cid: 'q-62331bf521774b174b35f079',
                name: '测试账号汇总',
                shops: ['智晓多谋水果专营店', 'sundayinsumme5'],
                limits: 20,
              },
              {
                cid: 'q-63ef3e97292f2a3ecb596b67',
                name: '企业2',
                shops: ['智潮流小店'],
                limits: 20,
              },
              {
                cid: 'q-63ef3e97292f2a3ecb596351',
                name: '企业3',
                shops: ['智晓多谋水果店', '智潮流小店'],
                limits: 20,
              },
            ],
          }),
        },
        {
          identifier: 'ShowCustomerAllOrderList_1726026728970',
          name: 'ShowCustomerAllOrderList',
          extraParams: JSON.stringify({
            month: 12,
          }),
        },
        {
          identifier: 'syncCaseToSubAccountPlugin_1730105813156',
          name: 'syncCaseToSubAccountPlugin',
        }, // 测试
        {
          identifier: 'HumanQaThreeRemarkInSession_1729602275023',
          name: 'HumanQaThreeRemarkInSession',
          extraParams: JSON.stringify(human_qa_three_remark_in_session_data),
        },
        {
          identifier: 'AddOrderFieldsToAlarm_1735628930174',
          name: 'AddOrderFieldsToAlarm',
        },
        {
          identifier: 'treeDefaultFoldPlugin_1741832722181',
          name: 'treeDefaultFoldPlugin',
        },
        {
          identifier: 'qcNormAudioPlugin_1743995531530',
          name: 'qcNormAudioPlugin',
          extraParams: '{"tenantId": "q-63563e97292f2a3ecb596b74", "platform": "open"}',
        },
        {
          identifier: 'extLinkBtnPlugin_1745486324675',
          name: 'extLinkBtnPlugin',
          extraParams: '{"platform": "open"}',
        },
      ],
      'tenant_id=q-626224cbcaf81553306790d4': [
        {
          identifier: 'ShowCustomerAllOrderList_1726026728970',
          name: 'ShowCustomerAllOrderList',
          extraParams: JSON.stringify({
            month: 12,
          }),
        },
      ],
    },
  })

  // 注册共享给插件的依赖
  // 为啥setTimeout？ 解决质检会话列表高级搜索条件显示的样式冲突问题（xdui和antd样式冲突）
  setTimeout(() => {
    sdk.registerDependencyShare('react', () => import('react'))
    sdk.registerDependencyShare('react-dom', () => import('react-dom'))
    sdk.registerDependencyShare('antd', () => import('antd'))
    sdk.registerDependencyShare('antd5', () => import('antd5'))
    sdk.registerDependencyShare('ahooks', () => import('ahooks'))
    sdk.registerDependencyShare('moment', () => import('moment'))
    sdk.registerDependencyShare('@main', () => import('./mainShare'))
    sdk.registerDependencyShare('dva', () => import('dva'))
    sdk.registerDependencyShare('@xiaoduo/plugin_sdk', () => import('@xiaoduo/plugin_sdk'))
    sdk.registerDependencyShare('@ant-design/icons', () => import('@ant-design/icons'))
    sdk.registerDependencyShare('ali-oss', () => import('ali-oss'))
    sdk.registerDependencyShare('lodash', () => import('lodash'))
  })

  // 注册共享给插件的能力
  sdk.registerMainShare(mainShare)

  // 先加载项目全局的插件， 可以按需加载指定用户的插件。 比如说 await sdk.loadPlugins("shop_id=xxx")
  // sdk.loadPlugins('*')
}
